<div class="user-management">
  <app-module-title moduleName="User Management"></app-module-title>

  <div class="action-tabs-container">
    <div class="custom-tabs">
      <div
        class="custom-tab"
        [ngClass]="{ 'active': activeTab === 'requests' }"
        (click)="navigateToTab('requests')"
      >
        Requests ({{ requestTotalRecords }})
      </div>
      <div
        class="custom-tab"
        [ngClass]="{ 'active': activeTab === 'users' }"
        (click)="navigateToTab('users')"
      >
        Users
      </div>
    </div>
    <div class="action-buttons-container">
      <p-button
        label="Create User"
        icon="pi pi-plus"
        [style]="{
          'background-color': 'var(--Yellow, #F0D413)',
          color: 'black',
          border: 'none',
          'font-weight': '500'
        }"
        (onClick)="handleCreateUser()"
      >
      </p-button>
    </div>
  </div>

  <div class="tab-content-container" >
    <!-- Router Outlet for child components -->
    <!-- Add a template reference variable to the router-outlet -->
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>

  <div *ngIf="showNewUserDialog">
    <app-user-form
      *ngIf="showNewUserDialog"
      [visible]="showNewUserDialog"
      (closeDialog)="showNewUserDialog = false"
      (showSuccessPopup)="onShowSuccessPopup($event)"
      (confirmDraft)="onConfirmDraft()"
      [draggable]="false"
    ></app-user-form>
  </div>

  <app-success-popup
    *ngIf="successPopupVisible"
    [visible]="successPopupVisible"
    [data]="successPopupData"
    (closeDialog)="onSuccessPopupClose()"
    (addAnother)="handleAddAnotherUser()"
  ></app-success-popup>

  <app-draft-popup
    [(visible)]="showDraftPopup"
    [data]="{ title: 'Save To Draft' }"
    (cancel)="onCancelDraft()"
    (confirm)="onConfirmDraft()"
    (navigateToDraft)="navigateToDraftTab()"
    [draggable]="false"
  ></app-draft-popup>
</div>